<script setup lang="ts">
/**
 * Horizontal page gutter and max width, in one place.
 *
 * Rendered as a `<div>` by default. Pass `as="section"` where the wrapper is also the semantic
 * grouping element — nesting a `<section>` inside a layout `<div>` that exists only for width adds
 * a landmark-free node to the accessibility tree for nothing.
 */

/**
 * Utilities
 */
import { cn } from '@/utils/cn'

const props = withDefaults(
  defineProps<{
    /** Element to render. */
    as?: string
    /** Extra classes, merged with `twMerge` so they can override the defaults. */
    class?: string
  }>(),
  { as: 'div', class: '' }
)
</script>

<template>
  <component :is="props.as" :class="cn('mx-auto w-full max-w-6xl px-6', props.class)">
    <slot />
  </component>
</template>
